<template>
  <div class="teacher-layout">
    <form action="/">
      <van-search
        v-model="kwSet[$route.name]"
        show-action
        placeholder="请输入"
        @search="searchHandler(kwSet[$route.name])"
      >
        <template #action>
          <div class="icon-wrapper">
            <van-icon
              name="wap-home"
              size="22"
              @click="$router.push({name: 'studio-teachers'})"
            />
          </div>
        </template>
      </van-search>
    </form>
    <div class="teacher-wrapper">
      <teacher-item float :item="item" />
      <teacher-tabbar />
    </div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
import { TeacherItem } from '@/components/item'
import TeacherTabbar from '@/components/tabbar/TeacherTabbar'
import { Teacher } from '@/api'

export default {
  name: 'TeacherLayout',
  components: { TeacherItem, TeacherTabbar },
  data: () => ({
    kwSet: {
      'teacher-courses': undefined,
      'teacher-videos': undefined,
      'teacher-creations': undefined
    },
    item: {}
  }),
  watch: {
    '$route.query.kw': {
      handler  (newKw, oldKw) {
        if (newKw !== oldKw) {
          this.kwSetFn(this.$route)
        }
      }
    },
    '$route.name': {
      handler (newName, oldName) {
        this.$router.replace({
          query: {
            kw: this.kwSet[this.$route.name]
          }
        })
      }
    }
  },
  async activated () {
    try {
      this.kwSetFn(this.$route)
      const { teacherId } = this.$route.params
      const { teacher: item } = await Teacher.detail({ teacherId })
      this.item = item
    } catch (error) {
      console.log(error)
    }
  },
  methods: {
    kwSetFn (route) {
      const { name, query: { kw }} = route
      this.kwSet[name] = kw
    },
    searchHandler (kw) {
      this.$router.push({
        query: {
          kw: kw || undefined
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.teacher-layout {
  @include mh-bgc(100vh, $color-bg);
  height: 100vh;
  padding-bottom: 50px;
  .van-search {
    padding-right: 0;
    .icon-wrapper {
      line-height: 0;
    }
  }
  .teacher-wrapper {
    padding: 10px 16px 10px;
    background-color: #fff;
    .teacher-item {
    }
  }
}
</style>
